import {RemoteGetHelpDeskSacLinkPage} from 'data/usecases/private/helpdesk-flow';
import {GetHelpDeskSacLinkPage} from 'domain/usecases';

import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {HelpDeskFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetHelpDeskSacLinkPage = (): GetHelpDeskSacLinkPage =>
	new RemoteGetHelpDeskSacLinkPage(
		makeBFFApiUrl(HelpDeskFlowEndpoints.ombudsman),
		makeAuthorizeHttpClientDecorator(),
	);
